import { useContext } from "react";
import {AuthContext} from "../Context/ProvideAuth";

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;